import { Api } from '../../utils/api/api';
import { setData, setError, startFetching } from '../actions';
import { bookDemoActionTypes as ACTION } from '../actionTypes';
import CONSTANTS from '../../constants/api.constants';

export const bookDemo = (arg) => {
  return async (dispatch) => {
    try {
      dispatch(startFetching(ACTION.BOOKDEMO_REQUEST));
      const data = await Api.post(`${CONSTANTS.baseUrl}${CONSTANTS.bookDemo}`, arg.details);
      if (data.status === 200) {
        if(arg.onSuccess){
          arg.onSuccess();
        }
        dispatch(
          setData(ACTION.BOOKDEMO_SUCCESS, {
            message: data.data.message,
          })
        );
      }
    } catch (error) {
      if (error && error.response && error.response.status === 400)
        dispatch(setError(ACTION.BOOKDEMO_FAILURE, error.response.data.message));
      else {
        dispatch(setError(ACTION.BOOKDEMO_FAILURE, 'Something Went Wrong!'));
      }
    }
  };
};
